import React from 'react';

const Blogs = () => {
    return (
        <div>
            <h1>blogs</h1>
        </div>
    );
};

export default Blogs; <h1>blogs</h1>